import { makeStyles, createStyles } from "@mui/styles";
import customColors from "../../styles/coreStyles/ColorPalette";
import customFonts from "../../styles/coreStyles/Fonts";

const DateFilterStyle = makeStyles(() =>
  createStyles({
    dateFilterBar: {
      display: "flex",
      // alignItems: "center",
      flexDirection: "column",
      // justifyContent: "center",
      marginTop: "1rem",
      padding: "10px",
    },
    headerText: {
      // width: "60px",
      // paddingRight: "1rem",
      fontSize: "16px",
      color: customColors.groupBlue,
      marginRight: "10px",
      fontFamily: customFonts.boldFont,
    },
  })
);

export default DateFilterStyle;
